import React from 'react';

import Header from 'components/Header/Header';
import BillableId from 'components/Header/BillableId/BillableId';
import ActionMenu from 'components/Header/ActionMenu/ActionMenu';
import Grid, { allowedLayouts } from 'foundations/Grids/Grid';
import GridBlock from 'foundations/Grids/GridBlock';
import ActionIcon from 'elements/ActionIcons/ActionIcon';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import { mainMenu, smallMenu } from './links';

export const defaultStandard = () => (
  <Grid layout={allowedLayouts.full}>
    <GridBlock modifier={'FullWidth'}>
      <Header className="main-content">
        <LinkFreeStanding
          size="m"
          icon={{direction: 'right', name: 'download', type:'20'}}
        >
          ITFS CDR SUMMARY
        </LinkFreeStanding>

        <ActionMenu withSeparator>
          <ActionIcon icon="manage-boards" type="navigation" />
          <ActionIcon icon="user" type="navigation" />
          <ActionIcon icon="notifications" type="navigation" />
        </ActionMenu>
      
        <BillableId
          title="Data Connectivity"
          opts={['Axis Capital', 'option2', 'option3', 'option4']}
          onChange={() => console.warn('Provide a callback to handle onChange')}
        />
      </Header>
    </GridBlock>
  </Grid>
);

export const defaultWithoutLink = () => (
  <Grid layout={allowedLayouts.full}>
    <GridBlock modifier={'FullWidth'}>
      <Header className="main-content">

        <ActionMenu>
          <ActionIcon icon="manage-boards" type="navigation" />
          <ActionIcon icon="user" type="navigation" />
          <ActionIcon icon="notifications" type="navigation" />
        </ActionMenu>
      
        <BillableId
          title="Data Connectivity"
          opts={['Axis Capital', 'option2', 'option3', 'option4']}
          onChange={() => console.warn('Provide a callback to handle onChange')}
        />
      </Header>
    </GridBlock>
  </Grid>
);

export const defaultWithoutBillable = () => (
  <Grid layout={allowedLayouts.full}>
    <GridBlock modifier={'FullWidth'}>
      <Header className="main-content">
        <LinkFreeStanding
          size="m"
          icon={{direction: 'right', name: 'download', type:'20'}}
        >
          ITFS CDR SUMMARY
        </LinkFreeStanding>

        <ActionMenu>
          <ActionIcon icon="manage-boards" type="navigation" />
          <ActionIcon icon="user" type="navigation" />
          <ActionIcon icon="notifications" type="navigation" />
        </ActionMenu>
      </Header>
    </GridBlock>
  </Grid>
);

export const defaultOnlyActionIcons = () => (
  <Grid layout={allowedLayouts.full}>
    <GridBlock modifier={'FullWidth'}>
      <Header className="main-content">
        <ActionMenu>
          <ActionIcon icon="manage-boards" type="navigation" />
          <ActionIcon icon="user" type="navigation" />
          <ActionIcon icon="notifications" type="navigation" />
        </ActionMenu>
      </Header>
    </GridBlock>
  </Grid>
);

export const statusPage = () => (
  <Header className="main-content">
    <ActionMenu statusPage>
      <ActionIcon icon="mail" type="20" />
      <ActionIcon icon="print" type="20" />
      <ActionIcon icon="download" type="20" />
    </ActionMenu>
  </Header>
);

export const landingPage = () => (
  <div style={{ height: 'calc(100vh + 800px)', marginTop: '110px'}}>
    <Header className="main-content" mainMenu={mainMenu} smallMenu={smallMenu}>
      <ActionMenu landing>
        <ActionIcon icon="user" type="navigation" exception />
        <ActionIcon icon="search" type="navigation" exception />
      </ActionMenu>
    </Header>
  </div>
);



// WEBPACK FOOTER //
// ./src/containers/components/Header/constants/headersLayouts.js